/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * common vertex shader for all point shaders
 */
const SHARED_SHADER = {
    uniforms: {
        size: { value: 1.0 },
    },
    vertexShader: `
    varying vec3 vColor;
    varying float fAlpha;
    attribute vec3 color;
    attribute float alpha;
    uniform float size;

    void main()
    {
        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
        gl_Position = projectionMatrix * mvPosition;
        vColor = color;
        fAlpha = alpha;
        float scale = 300.0;
        #ifdef USE_SIZEATTENUATION
            gl_PointSize = size * ( scale / - mvPosition.z );
        #else
            gl_PointSize = size;
        #endif
    }
`,
};
/**
 * shader to draw a simple filled circle
 */
export const LINE_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
          varying vec3 vColor;
          varying float fAlpha;
          void main()
          {
              gl_FragColor = vec4(vColor, fAlpha);
          }
      `,
};
/**
 * shader to draw a simple filled circle
 */
export const CIRCLE_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
        varying vec3 vColor;
        varying float fAlpha;

        void main()
        {
            vec2 uv = gl_PointCoord-0.5;
            if ( dot(uv, uv) > 0.25 )discard;
            gl_FragColor = vec4(vColor, 1.0);
        }
    `,
};
/**
 * shader to draw a simple filled rhombus
 */
export const RHOMBUS_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
        varying vec3 vColor;
        void main()
        {
            vec2 uv = gl_PointCoord-0.5;
            if ( (abs(uv.x)+abs(uv.y)) > 0.5 ) discard;
            gl_FragColor = vec4(vColor, 1.0);
        }
    `,
};
/**
 * shader to draw a simple filled triangle
 */
export const TRIANGLE_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
        varying vec3 vColor;
        void main()
        {
            vec2 uv = vec2(2.0*gl_PointCoord.x, 1.0-gl_PointCoord.y);
            if ( (uv.y>uv.x) || (uv.y>(2.0-uv.x)) ) discard;
            gl_FragColor = vec4(vColor,1.0);
        }
    `,
};
/**
 * shader to draw a simple filled cross
 */
export const CROSS_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
        varying vec3 vColor;
        void main()
        {
            vec2 uv = gl_PointCoord-0.5;
            if ( (abs(uv.y)>0.15) && (abs(uv.x)>0.15) ) discard;
            gl_FragColor = vec4(vColor,1.0);
        }
    `,
};
/**
 * shader to draw a pseudo raytraced sphere
 */
export const SPHERE_SHADER = {
    uniforms: SHARED_SHADER.uniforms,
    vertexShader: SHARED_SHADER.vertexShader,
    fragmentShader: `
        varying vec3 vColor;
        void main()
        {
            vec3 ns = vec3(-0.577,-0.577,0.577);

            vec2 uv = 2.0*gl_PointCoord-1.0;
            float l2 = dot(uv,uv);
            if(l2>1.0)discard;
            float z = sqrt(1.0-l2);
            vec3 n = vec3(uv,z);
            float spot = pow(dot(n,ns),9.0);
            vec3 col = vColor*z+spot;
            gl_FragColor = vec4(col,1.0);
        }
    `,
};
//# sourceMappingURL=ShapeShaders.js.map